<script setup lang="ts">
import type { PropertyOnList } from '@@/shared/property/api-types';

defineProps<{
  properties: Array<PropertyOnList>
}>();
</script>

<template>
  <div class="pt-l">
    <IadTitle :text="$t('property_serp.similar_properties')" />
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 py-m gap-xl max-w-screen-xl mx-auto">
      <PropertyCard
        v-for="property of properties"
        :key="property.propertyListingRef"
        :property
      />
    </div>
  </div>
</template>
